/**
 * HeroImageSection Component
 *
 * A simple hero section that displays just an image.
 *
 * Styling uses Bootstrap utility class props consistent with other sections.
 */
import React from "react";
import { filterClass } from "../../utils/class-utils";
import type { HeroImageSectionProps } from "../types";

export function HeroImageSection(props: HeroImageSectionProps) {
  const {
    image,
    imageAlt = "",
    imageWidth = "content",
    paddingYClass = "py-section-md",
    bgClass = "no-class",
  } = props;

  const hasImage = Boolean(image);
  const isFullWidth = imageWidth === "full";

  const sectionClassName = ["section section-hero-image", filterClass(bgClass), filterClass(paddingYClass)]
    .filter(Boolean)
    .join(" ")
    .trim();

  if (!hasImage) {
    return (
      <section className={sectionClassName || undefined}>
        <div className="container-xl">
          <div className="text-muted text-center py-5">No image selected</div>
        </div>
      </section>
    );
  }

  if (isFullWidth) {
    return (
      <section className={sectionClassName || undefined}>
        <img
          src={image}
          alt={imageAlt}
          className="img-fluid d-block mx-auto w-100"
        />
      </section>
    );
  }

  return (
    <section className={sectionClassName || undefined}>
      <div className="container-xl">
        <img
          src={image}
          alt={imageAlt}
          className="img-fluid d-block mx-auto"
        />
      </div>
    </section>
  );
}

export default HeroImageSection;

